import { playCircleIcon } from '@workday/canvas-system-icons-web'
import { createIcon } from './create-icon'
import { canvasIconPaths } from './canvasIconPaths'

export const PlayO = createIcon({
  displayName: 'PlayO',
  paths: [
    'M128 512c0-212.096 171.904-384 384-384s384 171.904 384 384c0 212.096-171.904 384-384 384s-384-171.904-384-384zM810.667 512c0-164.651-133.973-298.667-298.667-298.667s-298.667 134.016-298.667 298.667c0 164.651 133.973 298.667 298.667 298.667s298.667-134.016 298.667-298.667zM384 613.641v-203.264c0-31.701 33.365-52.395 61.739-38.187l203.264 101.632c31.445 15.701 31.445 60.629 0 76.331l-203.264 101.632c-28.373 14.165-61.739-6.443-61.739-38.144z'
  ],
  canvasPaths: canvasIconPaths(playCircleIcon)
})
